import { render, staticRenderFns } from "./WFCaseQueryPermissionAdd.vue?vue&type=template&id=193fbb3a&scoped=true"
import script from "./WFCaseQueryPermissionAdd.vue?vue&type=script&lang=js"
export * from "./WFCaseQueryPermissionAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193fbb3a",
  null
  
)

export default component.exports